/* eslint-disable import/no-anonymous-default-export */

export default {
    multicallAddress: {
        1: '0x9F454851093A664f78044DdEE41bD1E08797E440',
        56: '0xF2a32C23FCDDb5959d503a7abF315Cf6e61eE4cd',
        11155111: '0xadF8d01158AB8Bea6dfB5349a1Dc3d9FC4437Fb0',
        137: '0x1156256625faa48840Aea2Cd6f96418FDB4370fB',
        8453: '0x112284c273Ce5a01d43938312727d649a6Dbf569',
        10321: '0x46Cb98C22740A589Df59e3Aa0519913D8c811C42',
        97: '0xC79F14B813fdb5bf7fEa5428B110bf77a66a867F'
    },
    factoryAddress: {
        1: '0x57634eda509847aC548Af7c42d137FB5d3E5e7c0',
        56: '0x7b9fab8B72Cd88a82Df25E55E5C964084be80EE3',
        // '0x353B508949EcdF28A42B9C8924eb5C257301D04c',
        11155111: '0xFC23D8125E9b342fD8cAe4c4B6E816a83F0fe601',
        137: '0xE1C7759AebCd688e5f23B7C7A96a2dB87582A9Ae',
        8453: '0x031007b208AE73e4D63Ede6396128B449fE5aB5B',
        10321: '0x7091f5589a870d2655d89FD818C470b3070d5819',
        97: '0x57634eda509847aC548Af7c42d137FB5d3E5e7c0'
    },

    usdtAddress: {
        1: '0x34563DaCf93fA3df3A191ceC50d8E83B2E540348',
        56: '0xA3Fc96C283F647F4d3Bd8D346118d4F2905b7355',
        11155111: '0x4Ced8C61AFC318Ec2f82D83E9da52C4Ad2FF368B',
        137: '0xE1C7759AebCd688e5f23B7C7A96a2dB87582A9Ae',
        8453: '0x031007b208AE73e4D63Ede6396128B449fE5aB5B',
        10321: '0x7091f5589a870d2655d89FD818C470b3070d5819',
        // 97: '0xB95d249af48939BcA1b680a130da739728094dfA',
        97:'0xaB0173A441acAD6A3f7431923bC2C8056Ec050Ea'
    },
    contractAddress: {
        1: '0x0000000000000000000000000000000000000000',
        56: '0x0000000000000000000000000000000000000000',
        11155111: '0x0000000000000000000000000000000000000000',
        137: '0x0000000000000000000000000000000000000000',
        8453: '0x0000000000000000000000000000000000000000',
        10321: '0x0000000000000000000000000000000000000000',
        97: '0x0000000000000000000000000000000000000000',
    },
    WETHAddress: {
        1: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
        11155111: '0xb16F35c0Ae2912430DAc15764477E179D9B9EbEa',
        137: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
        8453: '0x4200000000000000000000000000000000000006',
        10321: '0x76132140d11907acd99c41397d890bf6b5258c4d',
        97: '0xB95d249af48939BcA1b680a130da739728094dfA',
    },
    routerAddress: {
        56: {
            'Pancakeswap': '0x10ED43C718714eb63d5aA57B78B54704E256024E',
        },
        97: {'Pancakeswap': '0xD99D1c33F9fC3444f8101754aBC46c52416550D1'},
    },
    defaultAddress: {
        1: '0x0000000000000000000000000000000000000000',
        56: '0x0000000000000000000000000000000000000000',
        11155111: '0x0000000000000000000000000000000000000000',
        137: '0x0000000000000000000000000000000000000000',
        8453: '0x0000000000000000000000000000000000000000',
        10321: '0x0000000000000000000000000000000000000000',
        97: '0x0000000000000000000000000000000000000000',
    },
}